import Core from './src/core/Core';
import CdnBalancer from './src/balancer/CdnBalancer';
import BalancerAnalytics from './src/balancer/video/BalancerAnalytics';
import Log, { LogLevel } from './src/common/log';
import NpawPluginOptions from './src/core/NpawPluginOptions';
global.LogLevel = LogLevel;
global.NpawPluginOptions = NpawPluginOptions;
export { LogLevel } from './src/common/log';
export * from './src/core/NpawPluginOptions';
export default class CdnBalancerPlugin {
    constructor(accountCode, options) {
        this.accountCode = accountCode;
        this.core = Core.getInstance(accountCode, options);
        this.video = this.createVideoAnalyticsIfEnabled((options === null || options === void 0 ? void 0 : options.balancerAnalyticsEnabled) === true);
        this.cdnBalancer = new CdnBalancer(accountCode, options, this.video);
    }
    destroy() {
        var _a;
        (_a = this.video) === null || _a === void 0 ? void 0 : _a.destroy();
        this.video = undefined;
        this.core.destroy();
        this.cdnBalancer.destroy();
    }
    /**
     * Changes the log level of the NPAW Plugin. See {@link LogLevel} for the different levels available
     *
     * @param logLevel Log level to be used
     */
    setLogLevel(logLevel) {
        Log.setLogLevel(logLevel);
    }
    /**
     * Sets Balancer options. See {@link BalancerOptions}.
     * @param options Balancer options
     */
    setBalancerOptions(options) {
        this.cdnBalancer.setOptions(options);
        const newVideo = this.createVideoAnalyticsIfEnabled(options.balancerAnalyticsEnabled === true);
        if (this.video && this.video !== newVideo) {
            this.video.destroy();
        }
        this.video = newVideo;
        this.cdnBalancer.setVideoLogic(this.video);
    }
    /**
     * Sets the manifest URL of the played content in the Balancer options object.
     * For url changes the loader is restarted.
     * @param url Manifest url of the content being played.
     * @public
     */
    setManifestResource(url) {
        this.cdnBalancer.setManifestResource(url);
    }
    /**
     * Adds an interceptor to the Balancer
     * @param name Name of the interceptor
     * @param player Video player object
     */
    addInterceptor(name, player) {
        this.cdnBalancer.addInterceptor(name, player);
    }
    /**
     * Returns Bitmovin configuration for request interception
     */
    getBitmovinSendHttpRequest() {
        return this.cdnBalancer.getBitmovinSendHttpRequest();
    }
    /**
     * Returns the manifest/video URL to be used following the Selector API.
     * If an error occurs this will return undefined
     */
    getRecommendedManifest() {
        return this.cdnBalancer.getRecommendedManifest();
    }
    /**
     * @internal
     * @returns True if balancer is enabled, false otherwise
     */
    isBalancerEnabled() {
        return this.cdnBalancer.getIsEnabled();
    }
    getManifestResolutionStats() {
        return this.cdnBalancer.getManifestResolutionStats();
    }
    setLegacyPlugin(legacyPlugin) {
        Core.getInstance().setLegacyPlugin(legacyPlugin);
    }
    createVideoAnalyticsIfEnabled(enabled) {
        if (!enabled) {
            return undefined;
        }
        if (this.video) {
            return this.video;
        }
        return new BalancerAnalytics(this.core, this.accountCode);
    }
}
